import {useMemo, useState} from "react";
import {PipelineFlowTransportEntity} from "@ots-frontend/ots-data";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";
import {useDebouncedValue} from "@mantine/hooks";

export type UsePipelineFlowTransportDataTableFilterProps = Omit<UseDataTableFilterProps<PipelineFlowTransportEntity>, 'filterConfig'>

export function usePipelineFlowTransportDataTableFilter(props: UsePipelineFlowTransportDataTableFilterProps): UseDataTableFilterResult<PipelineFlowTransportEntity> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [sourceObjectQuery, setSourceObjectQuery] = useState<string | undefined>(undefined);
  const [sourceObjectDebouncedQuery] = useDebouncedValue(sourceObjectQuery, 200);

  const [destObjectQuery, setDestObjectQuery] = useState<string | undefined>(undefined);
  const [destObjectDebouncedQuery] = useDebouncedValue(destObjectQuery, 200);

  const filterConfig: DataTableFilterConfig<PipelineFlowTransportEntity> = useMemo(() => {
    return {
      "sourceObject": {
        setQuery: setSourceObjectQuery,
        query: sourceObjectQuery,
        debouncedQuery: sourceObjectDebouncedQuery,
        filter: (record, query) => !record.source || !record.source.toLowerCase().includes(query.toLowerCase())
      },
      "destObject": {
        setQuery: setDestObjectQuery,
        query: destObjectQuery,
        debouncedQuery: destObjectDebouncedQuery,
        filter: (record, query) => !record.destination || !record.destination.toLowerCase().includes(query.toLowerCase())
      },
    }
  }, [
    sourceObjectQuery,
    sourceObjectDebouncedQuery,
    destObjectQuery,
    destObjectDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
